export default __webpack_public_path__ + "static/media/attendance.dbf49627.png";